export const isInt = n => !(n % 1);
export const isFloat = n => !!(n % 1);
